import { useTranslation } from 'react-i18next';

import LoadingPage from '@/components/common/LoadingPage';
import SubPageHeader from '@/components/common/SubPageHeader';
import hasItems from '@/lib/utils/hasItems';

import useSelectedParty from '../analysis/hooks/useSelectedParty';

import RiskObjectItem from './components/RiskObjectsSection/RiskObjectItem';
import useRiskObjects from './queries/hooks/useRiskObjects';

export default function RiskObjectsOverview() {
  const { t } = useTranslation();

  const party = useSelectedParty();

  const { data: riskObjects, isLoading } = useRiskObjects(party?.id ?? '', {
    enabled: Boolean(party?.id),
  });

  const allRiskObjects = Object.values(riskObjects ?? []).flat();

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>{t('RISK_OBJECTS_TITLE')}</SubPageHeader>

      <main className="flex flex-1 flex-col gap-2 overflow-y-auto p-2">
        {isLoading && <LoadingPage />}

        {!isLoading &&
          hasItems(allRiskObjects) &&
          allRiskObjects.map((riskObject) => (
            <RiskObjectItem
              key={riskObject.risk_object_id}
              riskObject={riskObject}
            />
          ))}
      </main>
    </div>
  );
}
